import { render, staticRenderFns } from "./ServiceOrdersListItem.vue?vue&type=template&id=eb054a1e"
import script from "./ServiceOrdersListItem.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../physical-world-status.locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Fdash-webapp%2Fdash-webapp%2Fsrc%2Fviews%2FPhysicalWorld%2FServiceOrders%2FServiceOrdersListItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports